import React, { FC } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { WorkExperienceData } from '../WorkExperience';
import { groupExperiencesByCompany } from '../utils/workExperienceUtils';
import { WorkExperienceItem } from './WorkExperienceItem';

export interface WorkExperienceListProps {
    experiences: WorkExperienceData[];
}

export const WorkExperienceList: FC<WorkExperienceListProps> = ({ experiences }) => {
    const companyGroups = groupExperiencesByCompany(experiences);

    return (
        <Stack direction="column" gap="6">
            {companyGroups.map((companyExperiences, index) => (
                <WorkExperienceItem
                    key={`${companyExperiences[0].company?.name}-${index}`}
                    companyExperiences={companyExperiences}
                />
            ))}
        </Stack>
    );
};
